import React, {useMemo, useState} from 'react';
import './styles/app.less';
import 'braft-editor/dist/output.css';
import 'normalize.css/normalize.css';
import 'snack-helper/dist/snack-helper.css';
import {AuthProvider, Alert, useAuthContext} from 'geestack-toolbox';
import {ConfigProvider, message} from 'antd';
import AxiosProvider from './Http/AxiosProvider';
import zhCN from 'antd/lib/locale/zh_CN';
import {onRequestFulfilled, onResponseReject} from './utils/HttpInstance';
import {Config} from './config';
import RootRouter from './pages/root';

const App: React.FunctionComponent<any> = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <AxiosProvider
          onResponseReject={onResponseReject}
          onRequestFulfilled={onRequestFulfilled}
          axiosConfig={{
            timeout: 15 * 60 * 1000,
            baseURL: Config.basePath,
          }}
          defaultErrorHandle={error => message.error(error.message)}>
          <RootRouter />
        </AxiosProvider>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
